import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import Http from 'services/http2';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import BillingService from 'services/billing';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import ModalService from 'services/modal';
import CommonFns from 'functions/common.ts';
function CostDetailDetail(props) {
  const Config = {
    purchase: {
      title: '供应商费用单详情',
      apiPath: '/costsheetOrder/detail',
      deleteApiPath: '/costsheetOrder/delete',
      customerNameKey: 'companyName',
      vendorNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_Reco_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Cost_Source_Type',
          subKey: 'sourceType',
          value: 'sourceTypeName'
        }
      ],
      idField: 'csoXkNo',
      wfmCode: '1002'
    },
    sale: {
      title: '客户费用单详情',
      apiPath: '/cCostsheetOrder/detail',
      deleteApiPath: '/cCostsheetOrder/delete',
      customerNameKey: 'companyName',
      vendorNameKey: 'innerCustomerName',
      arrEnumField: [
        {
          mainKey: 'B02_Reco_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Cost_Source_Type',
          subKey: 'sourceType',
          value: 'sourceTypeName'
        }
      ],
      idField: 'csoXkNo'
    }
  };

  const config = Config[props.type];

  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    moreSign1,
    moreSign2,
    handleMore,
    decimalPlace,
    fileList,
    setShowLoading,
    setError,
    setFileList,
    setRedirect,
    detail,
    setDetail,
    workflow,
    forceUpdate,
    self
  } = useDetail(props, config);

  const { state, dispatch } = useContext(ActionContext);
  const [boxState, setBoxState] = useState({
    1: true
  });

  const [canRecall, setCanRecall] = useState(false); //客户对账单是否可以撤回/
  const [companyParams, setCompanyParams] = useState({});

  //处理详情数据
  self.afterGetDetail = function (data) {
    if (self.isPurchase) {
      //todo
    } else {
      getWorkflowList({
        customerCode: data.customerCode,
        customerXkUniqueCode: data.customerXkUniqueCode,
        csoXkNo: data.csoXkNo
      });
    }

    data.rangeKey = data.costsheetMonth.replace(/(.{4})/g, val => {
      return val + '-';
    });
    //单身枚举
    data.lineList.forEach((item, i) => {
      item.lineAmountShow =
        data.isContainTax === 1 ? item.lineTaxAmount : item.lineAmount;
    });
    data.totalAmountShow =
      data.isContainTax === 1 ? data.totalTaxAmount : data.totalAmount;
    setDetail(data);
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  // function handleBoxState(idx) {
  //   boxState[idx] = !boxState[idx];
  //   setBoxState(boxState);
  //   forceUpdate();
  // }

  //发送
  function publish() {
    if (!self.isPurchase) {
      if (companyParams['Statement_Balance_Due_Written_By']) {
        if (Util.isEmpty(detail.lastMonthUnpaidAmount)) {
          ModalService.showError('上月应付余额不能为空', dispatch);
          return;
        }
        if (Util.isEmpty(detail.currentMonthUnpaidAmount)) {
          ModalService.showError('本月应付余额不能为空', dispatch);
          return;
        }
      }
    }
    let postbody = getPostbody(config.publishApiPath);
    BillingService.publishVStatement(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }
  //发布费用单 status取值：{1:发出；2:撤回; 5:作废}
  function handleCostOrder(action) {
    let postbody = {
      csoXkNo: detail.csoXkNo,
      companyCode: companyCode
    };
    BillingService.handleCostOrder(
      postbody,
      action,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //删除
  function handleDelete() {
    let postbody = getPostbody(config.deleteApiPath);
    BillingService.deleteCostsheet(
      postbody,
      () => {
        let url = '/mp/purchase/billing/cost/list';
        if (!self.isPurchase) {
          url = '/mp/sale/billing/cost/list';
        }
        setRedirect(url);
      },
      dispatch
    );
  }

  //{4:确认；3:退回;}
  function replyCostOrder(action) {
    let postbody = {
      csoXkNo: detail.csoXkNo,
      companyCode: companyCode
    };
    BillingService.replyCostOrder(
      postbody,
      action,
      () => {
        dispatch({ type: 'hideReject' });
        self.getDetail();
      },
      dispatch
    );
  }

  function handleCustExpenseSheet(action) {
    let postbody = {
      csoXkNo: detail.csoXkNo,
      companyCode: companyCode
    };
    BillingService.handleCustExpenseSheet(
      postbody,
      action,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //获取审批流状态
  async function getWorkflowList(obj) {
    let workflowXkNo = ''; //开始审批流的单据
    let startWorkflow = false; //是否开始审批流且未审批
    let workflowDetailList = [
      {
        customerCode: obj.customerCode,
        customerXkUniqueCode: obj.customerXkUniqueCode,
        billXkNoList: [obj.recoXkNo]
      }
    ];
    let postbody = {
      companyCode,
      workflowDetailList,
      apiPath: '/CworkflowBills/getList'
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = response.data[0];
        if (data) {
          workflowXkNo = data.billXkNo; //开始审批流的单据
          startWorkflow =
            [0, null].includes(data.status) && data.startFlag === 1; // 当前节点没有开始审批流 - 是开始节点;
        }
      }
    });
    setCanRecall(!workflowXkNo || startWorkflow);
  }

  //获取提交参数
  function getPostbody(apiPath) {
    let postbody = {
      csoXkNo: detail.csoXkNo,
      companyCode: companyCode,
      apiPath: apiPath
    };
    return postbody;
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="m-details-container">
        <div className="m-details-item">
          <div className="details-item-title">
            <label>基础信息</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                {self.isPurchase && (
                  <li>
                    <span className="field-label">供应商</span>
                    <div className="order-detail-value">
                      {detail[config.vendorNameKey]}({detail.innerVendorCode})
                    </div>
                  </li>
                )}
                {!self.isPurchase && (
                  <li>
                    <span className="field-label">客户名称</span>
                    <div className="order-detail-value">
                      {detail[config.vendorNameKey]}
                    </div>
                  </li>
                )}
                <li>
                  <span className="field-label">费用单号</span>
                  <div className="order-detail-value">{detail.csoErpNo}</div>
                </li>
                <li>
                  <span className="field-label">状态</span>
                  <div className="order-detail-value">
                    <span
                      className={
                        'u-sign ' +
                        CommonFns.getStatusClass(
                          'B02_Cost_Status',
                          detail.status
                        )
                      }
                    >
                      {detail.statusDesc}
                    </span>
                  </div>
                </li>
                <li>
                  <span className="field-label">收货部门</span>
                  <div className="order-detail-value">
                    {detail.profitCenterName}
                  </div>
                </li>
                <li>
                  <span className="field-label">发布时间</span>
                  <div className="order-detail-value">
                    {formatDate(detail.publishTime, 'YYYY-MM-DD HH:mm')}
                  </div>
                </li>
                <li>
                  <span className="field-label">发布人</span>
                  <div className="order-detail-value">{detail.publishName}</div>
                </li>

                {/* 审批流状态 仅开启后才显示 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批环节</span>
                    <div className="order-detail-value">
                      <WorkflowStatus
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                      />
                    </div>
                  </li>
                )}
                {/* 审批流按钮 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批操作</span>
                    <div className="order-detail-value">
                      <WorkflowButtons
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                        onChange={() => {
                          self.getDetail();
                        }}
                      />
                    </div>
                  </li>
                )}
                <li>
                  <span className="field-label">确认时间</span>
                  <div className="order-detail-value">
                    {formatDate(detail.confirmTime, 'YYYY-MM-DD HH:mm')}
                  </div>
                </li>
                <li>
                  <span className="field-label">确认人</span>
                  <div className="order-detail-value">{detail.confirmName}</div>
                </li>
                <li>
                  <span className="field-label">开户行</span>
                  <div className="order-detail-value">
                    {detail.openAccountBankName}
                  </div>
                </li>
                <li>
                  <span className="field-label">银行账号</span>
                  <div className="order-detail-value">{detail.bankCardNo}</div>
                </li>
                <li>
                  <span className="field-label">纳税人识别号</span>
                  <div className="order-detail-value">{detail.creditCode}</div>
                </li>
                <li>
                  <span className="field-label">币别</span>
                  <div className="order-detail-value">
                    {detail.currencyName}
                  </div>
                </li>
                <li>
                  <span className="field-label">税别</span>
                  <div className="order-detail-value">{detail.taxName}</div>
                </li>
                <li>
                  <span className="field-label">抵扣发票</span>
                  <div className="order-detail-value">
                    {detail.deductionType === 1 ? '是' : '否'}
                  </div>
                </li>
                <li>
                  <span className="field-label">是否内部</span>
                  <div className="order-detail-value">
                    {detail.isInterior === 1 ? '是' : '否'}
                  </div>
                </li>
                <li>
                  <span className="field-label">成本/利润中心</span>
                  <div className="order-detail-value">
                    {detail.centerType === 1
                      ? detail.erpProfitCenterName
                      : detail.costCenterName}
                  </div>
                </li>
                <li>
                  <span className="field-label">单据来源</span>
                  <div className="order-detail-value">
                    {detail.sourceTypeName}
                  </div>
                </li>
                <li>
                  <span className="field-label">应付凭证</span>
                  <div className="order-detail-value">
                    {detail.payCredentials}
                  </div>
                </li>
                <li>
                  <span className="field-label">总账凭证</span>
                  <div className="order-detail-value">
                    {detail.totalCredentials}
                  </div>
                </li>
                <li>
                  <span className="field-label">立账状态</span>
                  <div className="order-detail-value">{detail.lzStatus}</div>
                </li>
                <li>
                  <span className="field-label">费用周期</span>
                  <div className="order-detail-value">{detail.rangeKey}</div>
                </li>
              </ul>
            </div>
          </div>
          {/* <div
            className={moreSign1 ? 'm-more' : 'm-more m-more-open'}
            onClick={() => {
              handleMore(1);
            }}
          >
            {moreSign1 && '更多'}
            {!moreSign1 && '收起'}
            <i className="icon-down"></i>
          </div> */}
        </div>

        {/*费用单明细 */}
        {!Util.isEmpty(detail.lineList) && (
          <div className="m-details-item">
            <div className="details-item-title">
              <label>费用明细</label>
            </div>

            <div className="details-item-content">
              {detail.lineList.map((item, index) => (
                <div className="content-line line-list-item" key={index}>
                  <div className="line-list-item-title">
                    <span>项次 {item.lineNo}</span>
                  </div>
                  <ul className="field-list">
                    <li>
                      <span className="field-label">费用摘要</span>
                      <div className="field-value">{item.costAbstract}</div>
                    </li>
                    <li>
                      <span className="field-label">费用类型</span>
                      <div className="field-value">
                        {item.costType === 1 && '扣款'}
                        {item.costType === 2 && '补款'}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">费用原因</span>
                      <div className="field-value">
                        {item.costReasonEnumValue}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">费用类别</span>
                      <div className="field-value">{item.costTypeName}</div>
                    </li>
                    <li>
                      <span className="field-label">总账科目</span>
                      <div className="field-value">
                        <span>
                          {item.ledgerCourseCode} {item.ledgerCourseCode && ','}
                          {item.ledgerCourseName}
                        </span>
                      </div>
                    </li>
                    <li>
                      <span className="field-label">费用金额</span>
                      <div className="field-value">
                        <span>
                          {item.costType === 1 ? '-' : '+'}
                          {formatNumber(
                            item.lineAmountShow,
                            decimalPlace.Amount_Decimal_Place
                          )}
                        </span>
                      </div>
                    </li>
                    <li>
                      <span className="field-label">费用日期</span>
                      <div className="field-value">
                        {formatDate(item.costDate)}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">成本中心</span>
                      <div className="field-value">
                        <span>
                          {item.costCenterCode} {item.costCenterCode && ','}
                          {item.costCenterName}
                        </span>
                      </div>
                    </li>
                    <li>
                      <span className="field-label">内部订单</span>
                      <div className="field-value">
                        <span>
                          {item.erpInnerOrderCode}{' '}
                          {item.erpInnerOrderCode && ','}
                          {item.erpInnerOrder}
                        </span>
                      </div>
                    </li>
                    <li>
                      <span className="field-label">备注说明</span>
                      <div className="field-value">{item.costDesc}</div>
                    </li>
                  </ul>
                </div>
              ))}
            </div>
          </div>
        )}
        {/* 合计 */}
        <div className="m-details-item">
          <div className="details-item-title">
            <label>合计</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                <li>
                  <span className="field-label">合计金额</span>
                  <div className="order-detail-value">
                    {formatNumber(
                      detail.totalAmountShow,
                      decimalPlace.Amount_Decimal_Place
                    )}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('10040403') &&
            [0, 2, 3].includes(detail.status) &&
            detail.buildBy === 0 && (
              <Button
                type="default"
                onClick={() => {
                  handleCostOrder('publish');
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                发送
              </Button>
            )}
          {User.checkAuth('10040402') &&
            [0].includes(detail.status) &&
            detail.buildBy === 0 && (
              <Button
                type="default"
                onClick={() => {
                  handleDelete();
                }}
                className="m-flex-item u-btn u-btn_warn"
              >
                删除
              </Button>
            )}

          {User.checkAuth('10040404') &&
            detail.status === 1 &&
            workflow.data &&
            workflow.data['cost_cfm_4'].complete && (
              <Button
                type="default"
                onClick={() => {
                  replyCostOrder('confirm');
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                确认
              </Button>
            )}
          {User.checkAuth('10040405') &&
            [1].includes(detail.status) &&
            detail.buildBy === 1 && (
              <Button
                type="default"
                onClick={() => {
                  replyCostOrder('return');
                }}
                className="m-flex-item u-btn u-btn_warn"
              >
                退回
              </Button>
            )}
          {User.checkAuth('10040402') &&
            [2, 3, 4].includes(detail.status) &&
            detail.buildBy === 0 &&
            detail.invoiceStatus === 0 && (
              <Button
                type="default"
                onClick={() => {
                  handleCostOrder('void');
                }}
                className="m-flex-item u-btn u-btn_warn"
              >
                作废
              </Button>
            )}
        </div>
      )}

      {/* 客户订单操作 */}
      {!self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('20040305') &&
            [0, 2, 3].includes(detail.status) &&
            detail.buildBy === 1 && (
              <Button
                type="default"
                onClick={() => {
                  handleCustExpenseSheet('publish');
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                发送
              </Button>
            )}
          {User.checkAuth('20040304') && [0].includes(detail.status) && (
            <Button
              type="default"
              onClick={() => {
                handleDelete();
              }}
              className="m-flex-item u-btn u-btn_warn"
            >
              删除
            </Button>
          )}
          {User.checkAuth('20040305') &&
            detail.status === 1 &&
            detail.buildBy === 1 &&
            detail.invoiceStatus === 0 && (
              <Button
                type="default"
                onClick={() => {
                  handleCustExpenseSheet('withdraw');
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                撤回
              </Button>
            )}

          {User.checkAuth('20040304') &&
            [2, 3, 4].includes(detail.status) &&
            detail.buildBy === 1 &&
            detail.invoiceStatus === 0 && (
              <Button
                type="default"
                onClick={() => {
                  handleCustExpenseSheet('void');
                }}
                className="m-flex-item u-btn u-btn_warn"
              >
                作废
              </Button>
            )}
        </div>
      )}

      <Modal></Modal>
    </div>
  );
}

CostDetailDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CostDetailDetail);
